<ds-configuration-search-page configuration="administrativeView" [context]="context"></ds-configuration-search-page>
